// List of emails that should be redirected to the testing site
const TESTING_SITE_EMAILS = [
    'micahmurphy@bmss.com', 
    'pbolcar@bmss.com', 
    'troberts@bmss.com', 
    'jcorbin@bmss.com', 
    'hphillips@bmss.com', 
    'rking@bmss.com', 
    'aclark@bmss.com', 
    'gfatic@bmss.com', 
    'rmcdaniel@bmss.com', 
    'ematthewson@bmss.com', 
    'tpark@bmss.com', 
    'jwilliamson@bmss.com', 
    'rhathaway@bmss.com', 
    'hmarshall@bmss.com', 
    'rbowers@bmss.com', 
    'ajvanderwoude@bmss.com', 
    'troberts@bmss.com', 
    'mcapone@bmss.com'
];

// URL of the testing site
const TESTING_SITE_URL = 'https://bmss.network.magnify-app.com';

/**
 * Checks if a user should be redirected to the testing site based on their email
 * @param {string} userEmail - The user's email address
 * @returns {boolean} - True if the user should be redirected, false otherwise
 */
export const shouldRedirectToTestingSite = (userEmail) => {
    if (!userEmail) return false;
    return TESTING_SITE_EMAILS.includes(userEmail.toLowerCase());
};

/**
 * Redirects the user to the testing site if they meet the criteria
 * @param {string} userEmail - The user's email address
 */
export const handleTestingSiteRedirect = (userEmail) => {
    if (shouldRedirectToTestingSite(userEmail)) {
        window.location.href = TESTING_SITE_URL;
    }
}; 